import { MismatchDisplay, StatusDisplay } from "@/pages/COMMON/dashboard/potential/tabs/first-sale/helpers";
import { Box, Button, Tooltip, Typography } from "@mui/material";

export const createFirstSaleColumns = (
  handleStatusClick?: (row: any) => void,
  handleActionClick?: (row: any) => void,
  handleSavingsClick?: (row: any) => void
): IColumn<any>[] => [
  {
    name: "Manufacturer ID",
    key: "manufacturer",
    align: "left",
    width: "18%",
    component: (row) => (
      <Tooltip title={row.manufacturer} arrow>
        <Typography variant="body2" sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: { xs: '11px', md: '12px' } }}>
          {row.manufacturer}
        </Typography>
      </Tooltip>
    )
  },
  {
    name: "Manufacturer Name",
    key: "manufacturerName",
    align: "left",
    width: "22%",
    component: (row) => {
      return <Box sx={{ fontSize: { xs: '11px', md: '12px' } }}>{row.manufacturerName ?? "N/A"}</Box>;
    },
  },
  {
    name: "Related",
    key: "isRelated",
    align: "left",
    width: "10%",
    component: (row) => {
      return <Box sx={{ fontSize: { xs: '11px', md: '12px' } }}>{row.isRelated ? "Yes" : "No"}</Box>;
    },
  },
  {
    name: "Mismatch",
    key: "mismatch",
    align: "left",
    width: "12%",
    infoTooltip: "Mismatches between origin, export, and manufacturer data can indicate potential first sale opportunities",
    component: (row) => {
      return (
          <MismatchDisplay
            isExporter={row.isExporter}
            isManufacturer={row.isManufacturer}
          />
      );
    },
  },
  {
    name: "Second Sale Value",
    key: "tariffValue",
    align: "left",
    width: "14%",
    component: (row) => {
      return (
        <Box sx={{ fontSize: { xs: '11px', md: '12px' } }}>
          {row.tariffValue ? `$${row.tariffValue.toLocaleString()}` : "N/A"}
        </Box>
      );
    },
  },
  {
    name: "Duty Rate",
    key: "customValue",
    align: "left",
    width: "12%",
    component: (row) => {
      return <Box sx={{ fontSize: { xs: '11px', md: '12px' } }}>{(row.customValue * 100).toFixed(2) + "%"}</Box>;
    },
  },
  {
    name: "Potential Savings",
    key: "tariffDuty",
    align: "left",
    sorting: true,
    width: "12%",
    component: (row) => {
      return (
        <Box onClick={() => handleSavingsClick?.(row)} sx={{ fontSize: { xs: '11px', md: '12px' }, color: '#0B494B', fontWeight: 600, cursor: 'pointer' }}>
          {row.tariffDuty ? `$${(row.tariffDuty * 0.1).toFixed(2)}` : "$0"}
        </Box>
      );
    },
  },
  {
    name: "Status",
    key: "status",
    align: "left",
    width: "12%",
    component: (row) => {
      const status = row.submissionStatus?.[0]?.status || "Not contacted";
      return (
        <StatusDisplay
          status={status}
          onClick={() => handleStatusClick?.(row)}
        />
      );
    },
  },
  {
    name: "Action",
    key: "nextActions",
    align: "left",
    width: "12%",
    component: (row) => {
      const status = row.submissionStatus?.[0]?.status || "Not contacted";
      return (
        <Button
          variant={status === "Contacted" ? "outlined" : "contained"}
          color={status === "Vendor response received" ? "warning" : status === "Contacted" ? "info" : "primary"}
          size="small"
          onClick={() => handleActionClick?.(row)}
          sx={{ textTransform: "none", fontWeight: 600, borderRadius: "8px", minWidth: "max-content" }}
        >
          {status === "Contacted"
            ? "Resend Contact Form"
            : status === "Vendor response received"
            ? "Validate Report"
            : "Contact Vendor"}
        </Button>
      );
    },
  },
];

export const columns: IColumn<any>[] = createFirstSaleColumns();
